import { UseCase } from '@mdd/api';
import { User } from '../../models';

export class HasGossnerMemberCenterAccess implements UseCase<User | undefined, boolean> {
    execute(user: User | undefined): boolean {
        return !!user && user.permissions.includes('GOSSNER_MEMBER_CENTER');
    }
}
